import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { CheckboxListOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-checkbox-list/models/checkbox-list-option-i';
import { CheckboxListOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-checkbox-list/models/checkbox-list-option-loader-i';
import { getOneClickAdditionalServices } from '@ordersnproducts/modules/one-click-order/selectors/one-click-additional-services.selector';

@Injectable()
export class OneClickAdditionalServicesLoaderService implements CheckboxListOptionLoaderI {
  constructor(private store: Store<State>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<CheckboxListOptionI[]> {
    return this.store.pipe(
      select(getOneClickAdditionalServices),
      filter((additionalServices) => !!additionalServices),
      map((additionalServices) => {
        return additionalServices.map((additionalService) => {
          return {
            id: `${additionalService.additionalServiceId}`,
            name: `${additionalService.additionalServiceDesc}`,
          };
        });
      }),
    );
  }
}
